import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OffertKategori = lazy(() => import("@/pages/info/OffertKategori"));

export const Route = createFileRoute("/laddstolpar/")({
  head: () => seoHead("/laddstolpar", { description: "Laddstolpar för bostadsrättsföreningar, samfälligheter och arbetsplatser. Få kostnadsfria offerter på komplett laddinfrastruktur." }),
  component: () => <OffertKategori slug="laddstolpar" />,
});
